<template>
  <div :class="['input-wrapper', { 'input_error': error }, { 'input_disabled': disabled }]">
    <label
      v-if="label"
      :for="id"
      class="input__label"
    >
      {{ label }}
      <span v-if="required" class="input__label-required">*</span>
    </label>
    <div class="input__field-container">
      <input
        v-if="!isTextarea"
        :id="id"
        ref="input"
        :value="value"
        v-bind="$attrs"
        :maxlength="maxLength"
        :class="['input__field', {textarea: isTextarea}, textFieldClasses]"
        @input="onInput"
        @focus="onFocus"
        @blur="onBlur"
      >
      <textarea
        v-else
        :id="id"
        ref="input"
        v-bind="$attrs"
        :value="value"
        :maxlength="maxLength"
        :class="['input__field', {textarea: isTextarea}, textFieldClasses]"
        @input="onInput"
        @focus="onFocus"
        @blur="onBlur" 
      />

      <div 
        v-if="isTextarea"
        class="input__field-length"
      >
        {{ `${valueLength}  / ${maxLength}` }}
      </div>
    </div>
    <transition name="slide-from-top">
      <span
        v-if="error && errorMsg"
        class="input__error-msg"
      >
        {{ errorMsg }}
      </span>
    </transition>
  </div>
</template>

<script>

  export default {
    name: 'BaseInput',
    inheritAttrs: false,
    props: {
      value: {
        type: String,
        default: ''
      },
      label: {
        type: String,
        default: ''
      },
      maxLength: {
        type: String,
        default: ''
      },
      errorMsg: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        error: null,
        isOnFocus: false,
        valueLength: 0
      }
    },
    computed: {
      id () {
        return `input-${this._uid}`
      },
      required () {
        return 'required' in this.$attrs && this.$attrs.required
      },
      isTextarea () {
        return this.$attrs.type === 'textarea'
      },
      textFieldClasses () {
        return [
          { 'input__field_focus': this.isOnFocus },
          { 'input__field_has-content': this.value }
        ]
      },
      getValueLength () {
        return this.isTextarea ? this.$refs.input.value.length : ''
      }
    },
    watch: {
      errorMsg: {
        handler (msg) {
          console.log(this.error)
          this.error = !!msg
        }
      }
    },
    methods: {
      onInput (e) {
        this.error = false
        this.$emit('input', e.target.value)
        if (this.isTextarea) {
          this.valueLength = e.target.value.length
        }
      },
      onChange (e) {
        this.$emit('change', e.target.value)
      },
      onFocus () {
        this.isOnFocus = true

        this.$emit('focus')
      },

      onBlur () {
        this.isOnFocus = false


        if (this.$refs.input.hasAttribute('minlength') && this.$refs.input.value.length < parseInt(this.$refs.input.getAttribute('minlength'))) {
          this.error = true
        } else {
          this.error = false
        }

        switch (this.$attrs.name) {
        case 'name':
          this.isNameValid()
          break

        case 'email':
          this.isEmailValid()
          break

        case 'profession':
          this.isNameValid()
          break
        }

        this.$emit('blur')
      },
      isEmailValid () {
        /* eslint-disable */
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        this.error = !re.test(String(this.value).toLowerCase())

        this.$emit('error', this.error)

      },
       isNameValid () {
        /* eslint-disable */
        const re = /^(\s*[a-zA-zА-Яа-яЁёЇїІіЄєҐґ']\s*)*$/
        this.error = !re.test(this.value)

        this.$emit('error', this.error)

      },
    }
  }
</script>

<style lang="scss">
  .input {
    &-wrapper {
      position: relative;
      min-width: 290px;
    }

    &_disabled {
      pointer-events: none;
    }

    &__label {
      display: inline-block;
      font-size: 18px;
      line-height: 1.25;
      color: $c-light-black;

      &-required {
        color: $c-red;
      }
    }

    &__field {
      display: block;
      width: 100%;
      font-family: "FuturaPT";
      font-size: 18px;
      line-height: 1.25;
      padding: 12px;
      border: 2px solid #dbdbdb;
      outline: none;
      caret-color: $c-red;
      appearance: none;
      transition: 0.3s;

      @include mobile {
        padding: 11px;
        font-size: 16px;
      }


      @include placeholder {
        @include mobile {
          font-size: 14px;
        }
      }

      &:invalid {
        box-shadow: none;
      }

      &.textarea {
        padding-top: 20px;
        padding-bottom: 20px;
        overflow: auto;
        height: 96px;
        line-height: 1.25;
        resize: none;

        @include custom-scrollbar();
      }

      &-container {
        position: relative;
      }

      @include hover {
        border-color: #c2c2c2;
      }


      &_has-content {
        border-color: #c2c2c2;
      }

      &_focus {
        border-color: $c-yellow !important;
        caret-color: $c-yellow;
      }

      &-length {
        position: absolute;
        right: 14px;
        bottom: 6px;
        color: #797979;
        font-size: 14px;
        line-height: 1.34;
      }
    }

    &__error-msg {
      font-size: 14px;
      line-height: 1.34;
      color: $c-red;
    }

    &_error {
      .input__field {
        border-color: $c-red !important;

        @include placeholder {
          color: $c-red;
        }
      }
    }
  }
</style>
